import React from 'react';
import { utmMediumIconMap, utmMediumSvgMap, utmSourceIconMapInsensitive, utmSourceSvgMapInsensitive } from '../../../components/UTMIcons.js';
import { icons, logos } from '../../../images/index.js';
import SVG from 'images/svg/SVG.js';
import {utmMediumByValue, utmMediumValueByName} from "../../../selectors/appSelectors";
import {useSelector} from "react-redux";

const getUtmSourceIcon = (n) => utmSourceSvgMapInsensitive[(n || '').toLowerCase()] || icons[utmSourceIconMapInsensitive[(n || '').toLowerCase()]] || 'MarketingSource';
const getUtmMediumIcon = (n) => utmMediumSvgMap[(n || '').toLowerCase()] || icons[utmMediumIconMap[(n || '').toLowerCase()]] || 'MarketingMedium';

const MessageUTMBubbles = ({ message = {}, pipelineLead = {} }) => {
  const hasFacebookMessenger = ((message.message || {}).platform || {}).code === 'facebookmessenger';

  const utmMedium = pipelineLead.utm_medium || message.utmMedium;
  const hasMedium = !(!utmMedium || utmMedium === '(none)');
  const utmMediumName = useSelector(utmMediumByValue(utmMedium)) || utmMedium;
  const utmMediumValue = useSelector(utmMediumValueByName(utmMedium)) || utmMedium;

  const utmSource = pipelineLead.utm_source || message.utmSource;
  const hasSource = !(!utmSource || utmSource === '(none)');

  const utmCampaign = pipelineLead.utm_campaign || message.utmCampaign;
  const hasCampaign = !(!utmCampaign || utmCampaign === '(none)');

  const hasBubbles = hasFacebookMessenger || hasMedium || hasSource || hasCampaign || message.landingUrl || message.leadUrl;

  if (((!pipelineLead && !['web_forms', 'phone_calls', 'texts'].includes(message.type)) || !hasBubbles)) {
    return null;
  }

  const activeSourceIcon = getUtmSourceIcon(utmSource);
  const activeMediumIcon = getUtmMediumIcon(utmMediumValue);

  return (
    <div className={'utm-bubbles'}>
      {hasFacebookMessenger && (
        <span className={'utm-icon-bubble type'} data-title={'Facebook Messenger'}>
          <SVG icon={logos['facebook-messenger']} />
        </span>
      )}
      {hasMedium && (
        <span className={'utm-icon-bubble medium'} data-title={utmMediumName}>
          <SVG icon={activeMediumIcon} />
        </span>
      )}
      {hasSource && (
        <span className={'utm-icon-bubble'} data-title={utmSource}>
          {!["referredby", "Referred By"].includes(utmMedium) ? <SVG icon={activeSourceIcon} /> : utmSource}
        </span>
      )}
      {hasCampaign && (
        <span className={'utm-icon-bubble medium'} data-title={utmCampaign}>
          <SVG icon={'MarketingCampaign'} />
        </span>
      )}
      {!!message.landingUrl && (
        <span className={'utm-bubble'} data-title={`Landing Page: ${message.landingUrl}`}>
          <a href={message.landingUrl} target="_blank" rel="noopener noreferrer">
            <div className="label">Landing</div>
          </a>
        </span>
      )}
      {!!message.leadUrl && (
        <span className={'utm-bubble'} data-title={`Conversion Page: ${message.leadUrl}`}>
          <a href={message.leadUrl} target="_blank" rel="noopener noreferrer">
            <div className="label">Conversion</div>
          </a>
        </span>
      )}
    </div>
  );
};

export default MessageUTMBubbles;
